import { REPORT_CARD, REPORT_CARD_DETAILS, REPORT_FILTER, RESET_FILTERS, SEARCH_STUDENT_LIST, STUDENT_REPORT_LIST } from "../actions/types";

const initialState = {
   reportFilter: {
      classes: [],
      developmentPillars: [],
      kidIds: [],
      programs: [],
      schools: [],
      sections: [],
      teachers: [],
      kidIds: []
   },
   studentList: {},
   reportCard: {},
   reportCardDetails: {},
   searchStudentList: {}
}

export default function (state = initialState, action) {

   const { type, payload } = action;

   switch (type) {
      case STUDENT_REPORT_LIST:
         return { ...state, studentList: payload }
      case REPORT_FILTER:
         return { ...state, reportFilter: payload }
      case REPORT_CARD:
         return { ...state, reportCard: payload }
      case REPORT_CARD_DETAILS:
         return { ...state, reportCardDetails: payload }
      case SEARCH_STUDENT_LIST:
         return { ...state, searchStudentList: payload }
      case RESET_FILTERS:
         return {
            ...state, reportFilter: {
               classes: [],
               developmentPillars: [],
               kidIds: [],
               programs: [],
               schools: [],
               sections: [],
               teachers: [],
               kidIds: []
            }
         }
      default:
         return state;
   }
}